// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8920) return "static/chunks/8920-f7f8af5e0199ec12.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2237":"cfad00f6d798a6cd","2918":"0cb8c949edd4f7c7","4926":"5f50a78f56b1ea6b","6034":"93b88f495a5480f8","6048":"024a4d62af3c60a1","6263":"790a0d77066bfa18","6984":"8ae19c2a670de531","8090":"be7afb2ab64f4c2e","8741":"d178aaeedc13d2d1"}[chunkId] + ".js";
};